export default __webpack_public_path__ + "static/phone-5cf2152cc0728078645904909760ae07.png";